import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CalendarClock } from "lucide-react";

export const ScheduleSelection = ({ API, ids, onDone }) => {
  const [step, setStep] = useState(0);
  const plan = async () => {
    try {
      const { data: pre } = await axios.post(`${API}/mail/schedule`, { ids, step, dry_run: true });
      const label0 = step === 0 ? "de Toestemmingsmail" : `Mail ${step}`;
      if (!pre.eligible) {
        return pre.already_queued
          ? toast.info(`${pre.already_queued} van de ${ids.length} leads staan al in de wachtrij voor verzending. Bekijk de status in CRM & mailen → Verzenden via Hostnet.`, { duration: 10000 })
          : toast.info(`Geen van de ${ids.length} leads is aan de beurt voor ${label0} (al gevraagd, afgemeld of geen functie/naam bekend).`, { duration: 10000 });
      }
      const label = step === 0 ? "Toestemmingsmail" : `Mail ${step}`;
      if (!window.confirm(`${label} inplannen voor ${pre.eligible} lead(s)${pre.skipped ? ` (${pre.skipped} overgeslagen${pre.already_queued ? `, waarvan ${pre.already_queued} al in de wachtrij` : ""})` : ""}?\n\nDe app verstuurt ze rustig via je Hostnet-adressen binnen de verzendtijden.`)) return;
      const { data } = await axios.post(`${API}/mail/schedule`, { ids, step });
      toast.success(`${data.queued} mail(s) ingepland — volg ze in CRM & mailen → Verzenden via Hostnet`);
      onDone?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Inplannen mislukt");
    }
  };
  return (
    <div className="inline-flex items-center rounded-full border border-slate-900 overflow-hidden">
      <select data-testid="schedule-step-select" value={step} onChange={(e) => setStep(Number(e.target.value))}
        className="h-9 pl-3 pr-1 text-sm font-medium bg-slate-50 border-r border-slate-900 outline-none cursor-pointer">
        <option value={0}>Toestemmingsmail</option>
        <option value={1}>Mail 1</option>
        <option value={2}>Mail 2</option>
        <option value={3}>Mail 3</option>
      </select>
      <button data-testid="schedule-selection-button" onClick={plan}
        className="h-9 px-3 inline-flex items-center text-sm font-medium hover:bg-slate-100 transition-colors">
        <CalendarClock className="w-4 h-4 mr-1.5" strokeWidth={1.5} /> Inplannen via Hostnet ({ids.length})
      </button>
    </div>
  );
};
